import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationService } from '@services/api-calls/application.service';
import { catchError, map, of } from 'rxjs';

export const applicationInitGuard: CanActivateFn = (route) => {
    const applicationService = inject(ApplicationService);
    const router = inject(Router);

    // Extract GUID from route params
    const guid = route.params['guid'];

    // Validate GUID format
    if (!guid) {
        router.navigate(['/']);
        return false;
    }

    applicationService.applicationGuid.set(guid);

    // If no applicationId, initialize from GUID
    if (!applicationService.applicationId()) {
        return applicationService
            .createApplication({
                guid,
            })
            .pipe(
                map(() => true),
                catchError(() => {
                    router.navigate(['/']);
                    return of(false);
                }),
            );
    }

    return true;
};
